let config, player;

export default function (pl) {
  player = pl;
  config = player.config;
  player.on("ready", setPoster);
}

export function setPoster(e) {
  if (player?.config?.poster) {
    player.poster = player?.config?.poster;
  }
}
